import React from 'react';

const NoMatch = () => (
  <div className="nomatch">
    <h1>Page Not Found!</h1>
  </div>
);
export default NoMatch;
